import { uniqueId } from 'lodash'
import React, { FC } from 'react'

const Appropriate: FC = () => {
  const appropriates = [
    {
      linePositionLeft: 0,
      labelPositionLeft: 0,
      label: '危険',
      color: "#999999",
    },
    {
      linePositionLeft: 20,
      labelPositionLeft: 30,
      label: '要注意',
      color: "#999999",
    },
    {
      linePositionLeft: 60,
      labelPositionLeft: 70,
      label: '適正',
      color: "#4372BA",
    },
  ]

  return (
    <div
      style={{
        width: "100%",
        position: "relative",
      }}
    >
      {
        appropriates.map((appropriate) => (
          <React.Fragment key={uniqueId()}>
            <div
              style={{
                position: "absolute",
                top: "-13px",
                left: `${appropriate.labelPositionLeft}%`,
                width: "20%",
                textAlign: "center",
                color: appropriate.color,
                fontSize: "10px",
                lineHeight: "1em",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                }}
              >
                {appropriate.label}
              </span>
            </div>
          </React.Fragment>
        ))
      }
      <div
        style={{
          width: "100%",
          height: "24px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            height: "1px",
            width: "100%",
            backgroundColor: "#999",
            transform: "translateY(-50%)",
          }}
        />
        {
          appropriates.map((appropriate) => (
            <React.Fragment key={uniqueId()}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: `${appropriate.linePositionLeft}%`,
                  height: "14px",
                  width: "1px",
                  backgroundColor: "#999",
                  transform: "translateY(-50%)",
                }}
              />
            </React.Fragment>
          ))
        }
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "100%",
            height: "14px",
            width: "1px",
            backgroundColor: "#999",
            transform: "translateY(-50%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "60%",
            height: "4px",
            width: "40%",
            backgroundColor: "#4372BA",
            transform: "translateY(-50%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "60%",
            height: "14px",
            width: "2px",
            backgroundColor: "#4372BA",
            transform: "translateY(-50%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "100%",
            height: "14px",
            width: "2px",
            backgroundColor: "#4372BA",
            transform: "translateY(-50%)",
          }}
        />
      </div>
    </div>
  )
}

export default Appropriate
